module.exports = __webpack_public_path__ + "media/images/communities/logos/ao7-9ed9383db91a4d5a18710dbd0da7af4f.png";